<script setup>
import { computed, onMounted, ref } from 'vue';
import OrbixMonitorAPI from 'dashboard/api/orbixMonitor';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  path: {
    type: String,
    default: '',
  },
});

const token = ref('');
const isLoading = ref(true);
const loadError = ref('');
const iframeKey = ref(0);

const iframeSrc = computed(() => {
  const normalizedPath = props.path ? `/${props.path}` : '/';
  const params = new URLSearchParams({ embed: '1' });

  if (token.value) {
    params.set('token', token.value);
  }

  return `/orbix-monitor${normalizedPath}?${params.toString()}`;
});

const refreshFrame = () => {
  iframeKey.value += 1;
};

onMounted(async () => {
  try {
    const { data } = await OrbixMonitorAPI.getToken();
    token.value = data?.token || '';
  } catch (error) {
    loadError.value = 'Não foi possível carregar o Monitor Orbix.';
  } finally {
    isLoading.value = false;
  }
});
</script>

<template>
  <section class="flex h-full min-h-0 w-full flex-1 flex-col bg-n-background">
    <div class="min-h-0 flex-1">
      <div
        v-if="isLoading"
        class="flex h-full items-center justify-center bg-n-background text-sm text-n-slate-11"
      >
        Carregando...
      </div>
      <div
        v-else-if="loadError"
        class="flex h-full items-center justify-center bg-n-background text-sm text-n-ruby-11"
      >
        {{ loadError }}
      </div>
      <iframe
        v-else
        :key="iframeKey"
        class="block h-full min-h-[calc(100vh-1px)] w-full border-0 bg-n-background"
        :src="iframeSrc"
        :title="title"
      />
    </div>
  </section>
</template>
